export const SET_CURRENT_QUESTION = "SET_CURRENT_QUESTION";
export const SET_RETAKES = "SET_RETAKES";
export const SET_PROGRAMMING_QUESTION_STATUS =
  "SET_PROGRAMMING_QUESTION_STATUS";

export const setCurrentQuestion = (data) => ({
  type: SET_CURRENT_QUESTION,
  payload: data,
});

export const setRetakes = (count) => ({
  type: SET_RETAKES,
  payload: count,
});

export const setProgrammingQuestionStatus = (status) => ({
  type: SET_PROGRAMMING_QUESTION_STATUS,
  payload: status,
});
